module.exports = __webpack_public_path__ + "static/img/lunbo8.9e8132db.webp";